import { render, staticRenderFns } from "./PostRevise.vue?vue&type=template&id=5d29715f&scoped=true&"
import script from "./PostRevise.vue?vue&type=script&lang=js&"
export * from "./PostRevise.vue?vue&type=script&lang=js&"
import style0 from "./PostRevise.vue?vue&type=style&index=0&id=5d29715f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29715f",
  null
  
)

export default component.exports